import { POST, GET, PATCH, DELETE } from './Httpr.js';


export async function sendFriendRequest(request){
    let url = "relations/send";
    let requestData = {
        id: request
    };

    let rsp = await POST(url, requestData);

    return rsp;
}

export async function getFriendRequests(page = 1){
    let url = 'relations/requests';
    let requestData = {
        page: page
    }

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function acceptRequest(request){
    let url = "relations/accept";
    let requestData = {
        id: request
    }

    let rsp = await PATCH(url, requestData);

    return rsp;
}

export async function deleteFriend(request){
    let url = 'relations/delete';
    let requestData = {
        friend_id: request
    }

    let rsp = await DELETE(url, requestData);

    return rsp;
}


export async function getFriendsList(request){
    let url = 'relations/list';
    let requestData = {
        page: request.page,
        name: request.name
    }
    
    let rsp = await GET(url, requestData);

    return rsp;
}

export async function sendMessage(request){
    let url = 'inbox/send';

    let rsp = await POST(url, request);

    return rsp;
}

export async function getMessages(request){
    let url = 'inbox/messages';
    let requestData = {
        page: request?.page || 1,
        name: request?.name || "",
        title: request?.title || ""
    }

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function getSentMessages(request){
    let url = 'inbox/sentMessages';
    let requestData = {
        page: request?.page || 1,
        name: request?.name || "",
        title: request?.title || ""
    }

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function readMessage(request){
    let url = 'inbox/read';
    let requestData = {
        id: request
    };

    let rsp = await PATCH(url, requestData);

    return rsp;
}

export async function existUnread(){
    let url = 'inbox/exist';
    let requestData = {};

    let rsp = await GET(url, requestData);


    return rsp;
}

export async function pendingRequest(request){
    let url = 'relations/requested';
    let requestData = {
        page: request.page,
        name: request.name
    };

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function requiredRequest(request){
    let url = 'relations/required';
    let requestData = {
        page: request.page,
        name: request.name
    };

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function usersForRequest(request){
    let url = 'relations/users';
    let requestData = {
        page: request.page,
        name: request.name
    };

    let rsp = await GET(url, requestData);

    return rsp;
}

export async function existNewRequest(request){
    let url = 'relations/existRequest';
    
    let rsp = await GET(url, {});


    return rsp;
}